// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"117":"b806a36c","212":"e0cd4599","272":"500a9c8b","498":"453c8ea9","628":"deaef92c","729":"3defd672","746":"28618001","774":"b3f3fe51","787":"165c2155","898":"35154208"}[chunkId] + ".chunk.js";
};